<template lang="pug">
.bar-grafico
    .title-info-bar-grafico
        h2 {{ $t('mensagens.inteligenciaTerritorial.imovel.areaPlantadaUltimosCincoAnos') }}

    .grafico-area-plantada
        ApexCharts#graficoBarrasProducaoAgricola.component.apexcharts-canvas(
            type='bar',
            height='350',
            ref='chart',
            :options='chartOptionsAreaPlantada',
            :series='dadosAreaPlantada',
            @click='mostrarGleba'
        )
    el-divider
    h2 {{ $t('mensagens.inteligenciaTerritorial.imovel.produtividadeUltimosCincoAnos') }}
    .grafico-produtividade
        ApexCharts#graficoBarrasProducaoAgricola2.component.apexcharts-canvas(
            type='bar',
            height='350',
            ref='chart',
            :options='chartOptionsProdutividade',
            :series='dadosProdutividade',
            @click="mostrarGleba"
        )
</template>

<script>
import ApexCharts from 'vue-apexcharts';

export default {
    name: 'GraficoBarrasProducaoAgricola',
    components: {
        ApexCharts
    },
    props: {
        dadosAreaPlantada: {
            type: Array,
            default: () => []
        },
        dadosProdutividade: {
            type: Array,
            default: () => []
        },
        categoriasAreaPlantada: {
            type: Array,
            default: () => []
        },
        categoriasProdutividade: {
            type: Array,
            default: () => []
        },
        glebas: {
            type: Array,
            default: () => []
        },
        textoLegenda: {
            type: String,
            default: ''
        },
        unidadeProdutividade: {
            type: String,
            default: ''
        }
    },
    watch: {
        glebas(newValue) {
            this.glebas = newValue;
        }
    },
    data() {
        return {
            anoIndex: null
        };
    },
    computed: {
        chartOptionsAreaPlantada: {
            get() {
                const textoLegenda_ = this.textoLegenda;
                const categoriasAreaPlantada_ = this.categoriasAreaPlantada;

                return {
                    chart: {
                        type: 'bar',
                        height: 300,
                        offsetY: 20,
                        fontFamily: 'Roboto, sans-serif',
                        toolbar: {
                            show: false
                        }
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 7,
                            borderRadiusApplication: 'end',
                            columnWidth: '50%'
                        }
                    },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800,
                        animateGradually: {
                            enabled: true,
                            delay: 150
                        },
                        dynamicAnimation: {
                            enabled: true,
                            speed: 350
                        }
                    },
                    noData: {
                        text: this.$t('mensagens.inteligenciaTerritorial.naoHaDadosASeremMostrados'),
                        align: 'center',
                        verticalAlign: 'middle',
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            color: undefined,
                            fontSize: '14px',
                            fontFamily: undefined
                        }
                    },
                    grid: {
                        show: true,
                        position: 'back',
                        xaxis: {
                            lines: {
                                show: false
                            }
                        },
                        yaxis: {
                            lines: {
                                show: true
                            }
                        },
                        row: {
                            colors: undefined,
                            opacity: 0.5
                        },
                        column: {
                            colors: undefined,
                            opacity: 0.5
                        },
                        padding: {
                            top: 0,
                            right: 20,
                            bottom: 0,
                            left: 10
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    colors: '#FEC556',
                    stroke: {
                        width: 1,
                        colors: ['#fff']
                    },
                    title: {
                        text: ''
                    },
                    xaxis: {
                        categories: categoriasAreaPlantada_,
                        tickAmount: 8,
                        title: {
                            text: textoLegenda_,
                            offsetY: 95,
                            offsetX: 335,
                            style: {
                                color: '#3B3B3B',
                                fontSize: '14px',
                                fontFamily: 'Roboto, sans-serif',
                                fontWeight: 700
                            }
                        },
                        min: 0,
                        labels: {
                            style: {
                                color: '#3B3B3B',
                                fontSize: '14px',
                                fontFamily: 'Roboto, sans-serif',
                                fontWeight: 500
                            }
                        }
                    },
                    yaxis: {
                        title: {
                            text: this.$t('mensagens.inteligenciaTerritorial.areaPlantada') + ' (ha)',
                            style: {
                                cssClass:
                                    'apexcharts-yaxis-title-text-area-plantada'
                            }
                        },
                        labels: {
                            show: true,
                            align: 'left',
                            maxWidth: 150,
                            offsetX: -10,
                            style: {
                                color: '#3B3B3B',
                                fontSize: '14px',
                                fontFamily: 'Roboto, sans-serif',
                                fontWeight: 500
                            },
                            formatter(val) {
                                if (val >= 1000) {
                                    val /= 1000;
                                }

                                return val.toFixed(0);
                            }
                        },
                        tooltip: {
                            enabled: true
                        }
                    },
                    tooltip: {
                        fixed: {
                            enabled: false
                        },
                        custom: ({ seriesIndex, dataPointIndex, w }) => {
                            var valorHover = w.globals.initialSeries[
                                seriesIndex
                            ].data[dataPointIndex].toLocaleString('pt-BR', {
                                maximumFractionDigits: 0
                            });
                            const xaxisLabel = w.globals.labels[dataPointIndex];
                            this.updateAno(xaxisLabel);
                            return (
                                `<div class="customTooltip"><div><span>${this.$t('mensagens.inteligenciaTerritorial.areaPlantada')} | </span>` +
                                '<span>' +
                                xaxisLabel +
                                '</span>' +
                                '</div><div>' +
                                valorHover +
                                ' ha' +
                                '</div></div>'
                            );
                        }
                    },
                    fill: {
                        opacity: 1
                    },
                    legend: {
                        show: false
                    }
                };
            },
            set() {}
        },
        chartOptionsProdutividade: {
            get() {
                const textoLegenda_ = this.textoLegenda;
                const categoriasProdutividade_ = this.categoriasProdutividade;

                return {
                    chart: {
                        type: 'bar',
                        height: 300,
                        offsetY: 20,
                        fontFamily: 'Roboto, sans-serif',
                        toolbar: {
                            show: false
                        }
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 7,
                            borderRadiusApplication: 'end',
                            columnWidth: '50%'
                        }
                    },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800,
                        animateGradually: {
                            enabled: true,
                            delay: 150
                        },
                        dynamicAnimation: {
                            enabled: true,
                            speed: 350
                        }
                    },
                    noData: {
                        text: this.$t('mensagens.inteligenciaTerritorial.naoHaDadosASeremMostrados'),
                        align: 'center',
                        verticalAlign: 'middle',
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            color: undefined,
                            fontSize: '14px',
                            fontFamily: undefined
                        }
                    },
                    grid: {
                        show: true,
                        position: 'back',
                        xaxis: {
                            lines: {
                                show: false
                            }
                        },
                        yaxis: {
                            lines: {
                                show: true
                            }
                        },
                        row: {
                            colors: undefined,
                            opacity: 0.5
                        },
                        column: {
                            colors: undefined,
                            opacity: 0.5
                        },
                        padding: {
                            top: 15,
                            right: 20,
                            bottom: 20,
                            left: 10
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    colors: '#FEC556',
                    stroke: {
                        width: 1,
                        colors: ['#fff']
                    },
                    title: {
                        text: ''
                    },
                    xaxis: {
                        categories: categoriasProdutividade_,
                        tickAmount: 8,
                        title: {
                            text: textoLegenda_,
                            offsetY: 95,
                            offsetX: 335,
                            style: {
                                color: '#3B3B3B',
                                fontSize: '14px',
                                fontFamily: 'Roboto, sans-serif',
                                fontWeight: 700
                            }
                        },
                        min: 0,
                        labels: {
                            style: {
                                color: '#3B3B3B',
                                fontSize: '14px',
                                fontFamily: 'Roboto, sans-serif',
                                fontWeight: 500
                            }
                        }
                    },
                    yaxis: {
                        title: {
                            text: this.$t('mensagens.inteligenciaTerritorial.imovel.produtividade') + ' ' + this.unidadeProdutividade,
                            offsetY: 0,
                            offsetX: 0,
                            style: {
                                cssClass:
                                    'apexcharts-yaxis-title-text-produtividade'
                            }
                        },
                        labels: {
                            show: true,
                            align: 'left',
                            maxWidth: 150,
                            offsetX: -10,
                            style: {
                                color: '#3B3B3B',
                                fontSize: '14px',
                                fontFamily: 'Roboto, sans-serif',
                                fontWeight: 500
                            },
                            formatter(val) {
                                if (val >= 1000) {
                                    val /= 1000;
                                }

                                return val.toFixed(0);
                            }
                        },
                        tooltip: {
                            enabled: true
                        }
                    },
                    tooltip: {
                        fixed: {
                            enabled: false,
                            position: 'topLeft'
                        },
                        marker: {
                            show: true
                        },
                        custom: ({ seriesIndex, dataPointIndex, w }) => {
                            var valorHover = w.globals.initialSeries[
                                seriesIndex
                            ].data[dataPointIndex].toLocaleString('pt-BR', {
                                maximumFractionDigits: 0
                            });
                            const xaxisLabel = w.globals.labels[dataPointIndex];
                            this.updateAno(xaxisLabel);
                            return (
                                `<div class="customTooltip"><div><span>${this.$t('mensagens.inteligenciaTerritorial.imovel.produtividade')} | </span>` +
                                '<span>' +
                                xaxisLabel +
                                '</span>' +
                                '</div><div>' +
                                valorHover +
                                ' sacas/ha' +
                                '</div></div>'
                            );
                        }
                    },
                    fill: {
                        opacity: 1
                    },
                    legend: {
                        show: false
                    }
                };
            },
            set() {}
        }
    },
    methods: {
        mostrarGleba() {
            this.glebas.forEach(index => {
                if (index.ano === this.anoIndex) {
                    const gleba = index.geometria;
                    this.$store.dispatch('setGlebaVisualizada', gleba);
                }
            });
        },
        updateAno(ano) {
            this.anoIndex = ano;
        }
    }
};
</script>

<style lang="scss">
#graficoBarrasProducaoAgricola,
#graficoBarrasProducaoAgricola2 {
    font-family: 'Roboto', 'sans serif';
    max-height: 265px;

    .apexcharts-tooltip.apexcharts-theme-light {
        background: none !important;
        border: none !important;
    }

    .apexcharts-yaxis-title-text-area-plantada {
        transform: translateX(72px) translateY(-120px) rotate(0deg);
        font-size: 14px;
        color: #3b3b3b;
        font-family: 'Roboto', sans-serif;
        font-weight: 700;
    }

    .apexcharts-yaxis-title-text-produtividade {
        transform: translateX(91px) translateY(-120px) rotate(0deg);
        font-size: 14px;
        color: #3b3b3b;
        font-family: 'Roboto', sans-serif;
        font-weight: 700;
    }
}

.title-info-bar-grafico {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    .info-bar-grafico {
        i,
        span {
            font-size: 14px;
            font-weight: 500;
            line-height: 16px;
            text-align: left;
            color: #3b3b3b;
        }
    }
}

.customTooltip {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px;
    background-color: #3b3b33cc;
    border-radius: 8px;

    div {
        color: #ffffff;
        font-size: 16px;
        line-height: 10px;
        font-weight: 500;

        &:first-child {
            margin-bottom: 18px;
        }
    }
}
</style>
